export interface ICommand { }

export class AddDatasetItemCommandV1 implements ICommand {
	$type: string = 'TCh.Domain.Integrations.Datasets.Commands.AddDatasetItemCommandV1, TCh.Domain.Integrations'

	Id: string
	OrganizationUnitId: string
	UpdatedBy: string
	IdPropertyName: string
	ItemId: string
	RunId: string | null

	constructor (id: string, organizationUnitId: string, updatedBy: string, idPropertyName: string, itemId: string, runId: string | null)
	{
		this.Id = id
		this.OrganizationUnitId = organizationUnitId
		this.UpdatedBy = updatedBy
		this.IdPropertyName = idPropertyName
		this.ItemId = itemId
		this.RunId = runId
	}

	static matchType(cmd: any)	{
		return cmd.$type == 'TCh.Domain.Integrations.Datasets.Commands.AddDatasetItemCommandV1, TCh.Domain.Integrations'
	}

}

export class AddDatasetItemCommandV2 implements ICommand {
	$type: string = 'TCh.Domain.Integrations.Datasets.Commands.AddDatasetItemCommandV2, TCh.Domain.Integrations'

	Id: string
	OrganizationUnitId: string
	UpdatedBy: string
	ItemId: any
	RunId: string | null

	constructor (id: string, organizationUnitId: string, updatedBy: string, itemId: any, runId: string | null)
	{
		this.Id = id
		this.OrganizationUnitId = organizationUnitId
		this.UpdatedBy = updatedBy
		this.ItemId = itemId
		this.RunId = runId
	}

	static matchType(cmd: any)	{
		return cmd.$type == 'TCh.Domain.Integrations.Datasets.Commands.AddDatasetItemCommandV2, TCh.Domain.Integrations'
	}

}

export class ChangeDatasetItemPropertyCommandV1 implements ICommand {
	$type: string = 'TCh.Domain.Integrations.Datasets.Commands.ChangeDatasetItemPropertyCommandV1, TCh.Domain.Integrations'

	Id: string
	OrganizationUnitId: string
	UpdatedBy: string
	IdPropertyName: string
	ItemId: string
	PropertyName: string
	OldValue: any
	NewValue: any
	RunId: string | null

	constructor (id: string, organizationUnitId: string, updatedBy: string, idPropertyName: string, itemId: string, propertyName: string, oldValue: any, newValue: any, runId: string | null)
	{
		this.Id = id
		this.OrganizationUnitId = organizationUnitId
		this.UpdatedBy = updatedBy
		this.IdPropertyName = idPropertyName
		this.ItemId = itemId
		this.PropertyName = propertyName
		this.OldValue = oldValue
		this.NewValue = newValue
		this.RunId = runId
	}

	static matchType(cmd: any)	{
		return cmd.$type == 'TCh.Domain.Integrations.Datasets.Commands.ChangeDatasetItemPropertyCommandV1, TCh.Domain.Integrations'
	}

}

export class ChangeDatasetItemPropertyCommandV2 implements ICommand {
	$type: string = 'TCh.Domain.Integrations.Datasets.Commands.ChangeDatasetItemPropertyCommandV2, TCh.Domain.Integrations'

	Id: string
	OrganizationUnitId: string
	UpdatedBy: string
	ItemId: any
	PropertyName: string
	OldValue: any
	NewValue: any
	RunId: string | null

	constructor (id: string, organizationUnitId: string, updatedBy: string, itemId: any, propertyName: string, oldValue: any, newValue: any, runId: string | null)
	{
		this.Id = id
		this.OrganizationUnitId = organizationUnitId
		this.UpdatedBy = updatedBy
		this.ItemId = itemId
		this.PropertyName = propertyName
		this.OldValue = oldValue
		this.NewValue = newValue
		this.RunId = runId
	}

	static matchType(cmd: any)	{
		return cmd.$type == 'TCh.Domain.Integrations.Datasets.Commands.ChangeDatasetItemPropertyCommandV2, TCh.Domain.Integrations'
	}

}

export class ClearDatasetItemsCommandV1 implements ICommand {
	$type: string = 'TCh.Domain.Integrations.Datasets.Commands.ClearDatasetItemsCommandV1, TCh.Domain.Integrations'

	Id: string
	OrganizationUnitId: string
	UpdatedBy: string
	UpdatedAt: any

	constructor (id: string, organizationUnitId: string, updatedBy: string, updatedAt: any)
	{
		this.Id = id
		this.OrganizationUnitId = organizationUnitId
		this.UpdatedBy = updatedBy
		this.UpdatedAt = updatedAt
	}

	static matchType(cmd: any)	{
		return cmd.$type == 'TCh.Domain.Integrations.Datasets.Commands.ClearDatasetItemsCommandV1, TCh.Domain.Integrations'
	}

}

export class CreateDatasetCommandV1 implements ICommand {
	$type: string = 'TCh.Domain.Integrations.Datasets.Commands.CreateDatasetCommandV1, TCh.Domain.Integrations'

	Id: string
	OrganizationUnitId: string
	CreatedBy: string
	Name: string

	constructor (id: string, organizationUnitId: string, createdBy: string, name: string)
	{
		this.Id = id
		this.OrganizationUnitId = organizationUnitId
		this.CreatedBy = createdBy
		this.Name = name
	}

	static matchType(cmd: any)	{
		return cmd.$type == 'TCh.Domain.Integrations.Datasets.Commands.CreateDatasetCommandV1, TCh.Domain.Integrations'
	}

}

export class DeleteDatasetCommandV1 implements ICommand {
	$type: string = 'TCh.Domain.Integrations.Datasets.Commands.DeleteDatasetCommandV1, TCh.Domain.Integrations'

	Id: string
	OrganizationUnitId: string
	DeletedBy: string

	constructor (id: string, organizationUnitId: string, deletedBy: string)
	{
		this.Id = id
		this.OrganizationUnitId = organizationUnitId
		this.DeletedBy = deletedBy
	}

	static matchType(cmd: any)	{
		return cmd.$type == 'TCh.Domain.Integrations.Datasets.Commands.DeleteDatasetCommandV1, TCh.Domain.Integrations'
	}

}

export class PermanentDeleteDatasetCommandV1 implements ICommand {
	$type: string = 'TCh.Domain.Integrations.Datasets.Commands.PermanentDeleteDatasetCommandV1, TCh.Domain.Integrations'

	Id: string

	constructor (id: string)
	{
		this.Id = id
	}

	static matchType(cmd: any)	{
		return cmd.$type == 'TCh.Domain.Integrations.Datasets.Commands.PermanentDeleteDatasetCommandV1, TCh.Domain.Integrations'
	}

}

export class RemoveDatasetItemCommandV1 implements ICommand {
	$type: string = 'TCh.Domain.Integrations.Datasets.Commands.RemoveDatasetItemCommandV1, TCh.Domain.Integrations'

	Id: string
	OrganizationUnitId: string
	UpdatedBy: string
	UpdatedAt: any
	IdPropertyName: string
	ItemId: string
	RunId: string | null

	constructor (id: string, organizationUnitId: string, updatedBy: string, updatedAt: any, idPropertyName: string, itemId: string, runId: string | null)
	{
		this.Id = id
		this.OrganizationUnitId = organizationUnitId
		this.UpdatedBy = updatedBy
		this.UpdatedAt = updatedAt
		this.IdPropertyName = idPropertyName
		this.ItemId = itemId
		this.RunId = runId
	}

	static matchType(cmd: any)	{
		return cmd.$type == 'TCh.Domain.Integrations.Datasets.Commands.RemoveDatasetItemCommandV1, TCh.Domain.Integrations'
	}

}

export class RemoveDatasetItemCommandV2 implements ICommand {
	$type: string = 'TCh.Domain.Integrations.Datasets.Commands.RemoveDatasetItemCommandV2, TCh.Domain.Integrations'

	Id: string
	OrganizationUnitId: string
	UpdatedBy: string
	UpdatedAt: any
	ItemId: any
	RunId: string | null

	constructor (id: string, organizationUnitId: string, updatedBy: string, updatedAt: any, itemId: any, runId: string | null)
	{
		this.Id = id
		this.OrganizationUnitId = organizationUnitId
		this.UpdatedBy = updatedBy
		this.UpdatedAt = updatedAt
		this.ItemId = itemId
		this.RunId = runId
	}

	static matchType(cmd: any)	{
		return cmd.$type == 'TCh.Domain.Integrations.Datasets.Commands.RemoveDatasetItemCommandV2, TCh.Domain.Integrations'
	}

}

